;(function () {
  var AMPLITUDE_KEY = '40b3f4ce5bf8c1a16cbb45a131432f0a';

  function bootAmplitude() {
    if (window.__DRESSX_AMPLITUDE_BOOTED) return;
    window.__DRESSX_AMPLITUDE_BOOTED = true;
    window.is_amplitude_enabled = true;
    var sdk = document.createElement('script');
    sdk.src = 'https://cdn.amplitude.com/script/' + AMPLITUDE_KEY + '.js';
    sdk.async = true;
    sdk.onload = function () {
      try {
        if (window.amplitude && window.amplitude.init) {
          window.amplitude.init(AMPLITUDE_KEY, {
            fetchRemoteConfig: true,
            autocapture: {
              attribution: true, fileDownloads: true, formInteractions: false,
              pageViews: false, sessions: true, elementInteractions: false,
              networkTracking: false, webVitals: false,
              frustrationInteractions: {
                thrashedCursor: false, errorClicks: false,
                deadClicks: false, rageClicks: false
              }
            }
          });
        }
        if (window.amplitude && typeof window.amplitude.track === 'function') {
          window.dispatchEvent(new CustomEvent('dressx:amplitude-ready'));
        }
      } catch (e) {
        console.warn('DRESSX: failed to initialize Amplitude.', e);
      }
    };
    document.head.appendChild(sdk);
  }

  bootAmplitude();

  var TRYON_FLAG_KEY = 'dressx_try_on_completed';
  var EMAIL_FLAG_KEY = 'dressx_email_submitted_pending';
  var LOGIN_FLAG_KEY = 'dressx_login_pending';

  function amp() {
    return (window.amplitude && typeof window.amplitude.track === 'function') ? window.amplitude : null;
  }

  var queue = [];
  var flushTimer = null;
  var attempts = 0;

  var STOREFRONT_VERSION = '1.0.0';
  function track(name, props) {
    var payload = props || {};
    if (payload.version === undefined) payload.version = STOREFRONT_VERSION;
    var a = amp();
    if (a) { a.track(name, payload); return; }
    if (queue.length < 60) queue.push([name, payload]);
    scheduleFlush();
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = setTimeout(function () {
      flushTimer = null;
      var a = amp();
      if (a) {
        while (queue.length) { var it = queue.shift(); a.track(it[0], it[1]); }
        return;
      }
      attempts += 1;
      if (attempts > 20) {
        if (!window.__DRESSX_AMP_WARNED) {
          window.__DRESSX_AMP_WARNED = true;
          console.warn('DRESSX: window.amplitude never appeared - ' + queue.length
            + ' store event(s) dropped. The Amplitude SDK is not loaded on this page.');
        }
        queue.length = 0;
        return;
      }
      scheduleFlush();
    }, 1000);
  }

  function currentTemplate() {
    var body = document.body;
    if (body) {

      var cls = String(body.className || '');
      var m = cls.match(/(?:^|\s)main--([a-z0-9_-]+)/i) || cls.match(/(?:^|\s)template-([a-z0-9_-]+)/i);
      if (m) return m[1].toLowerCase();
      var attr = body.getAttribute && body.getAttribute('data-template');
      if (attr) return String(attr).toLowerCase();
    }

    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var type = meta && meta.page && meta.page.pageType;
      if (type) return String(type).toLowerCase();
    } catch (e) {}
    return '';
  }

  function isSignedIn() {
    if (typeof window.__DRESSX_SIGNED_IN === 'boolean') return window.__DRESSX_SIGNED_IN;

    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var customerId = meta && meta.page && meta.page.customerId;
    if (customerId) return true;
    return !!document.querySelector('a[href*="/account/logout"]');
  }

  function hasCompletedTryOn() {
    try { return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'; } catch (e) { return false; }
  }

  var CART_TRYON_ATTR = 'dressx_try_on_completed';
  var cartMarkInFlight = null;
  function markCartTryOnCompleted() {
    if (!hasCompletedTryOn()) return Promise.resolve();
    if (cartMarkInFlight) return cartMarkInFlight;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { attributes: {} };
    body.attributes[CART_TRYON_ATTR] = 'true';
    cartMarkInFlight = fetch(root.replace(/\/?$/, '/') + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
    return cartMarkInFlight;
  }

  function params() {
    return (typeof window.__DRESSX_TRYON_PARAMS === 'object' && window.__DRESSX_TRYON_PARAMS) || {};
  }

  function getCurrency(fallback) {
    if (fallback) return String(fallback);
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return String(window.Shopify.currency.active);
      }
    } catch (e) {}
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.currency) return String(meta.currency);
    } catch (e) {}

    try {
      if (window.__DRESSX_STORE_CURRENCY) return String(window.__DRESSX_STORE_CURRENCY);
    } catch (e) {}
    return '';
  }

  function shopifyMeta() {
    try { return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || null; } catch (e) { return null; }
  }
  function metaProduct() {
    var m = shopifyMeta();
    return (m && m.product) || null;
  }

  function currentVariantId() {
    try {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
    } catch (e) {}
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}
    var m = shopifyMeta();
    if (m && m.selectedVariantId) return String(m.selectedVariantId);
    return '';
  }
  function metaVariant(variantId) {
    var prod = metaProduct();
    if (!prod || !Array.isArray(prod.variants)) return null;
    var id = String(variantId || currentVariantId() || '');
    for (var i = 0; i < prod.variants.length; i++) {
      if (String(prod.variants[i].id) === id) return prod.variants[i];
    }
    return prod.variants[0] || null;
  }

  function money(cents) {
    if (cents == null || cents === '') return null;
    var n = Number(cents);
    if (isNaN(n)) return null;
    return n / 100;
  }

  function productProps(extra) {
    var p = params();
    var prod = metaProduct();
    var v = metaVariant();
    var out = {};
    var id = p.id != null ? p.id : (prod && prod.id);
    if (id != null) out.id = id;
    var sku = p.sku || (v && v.sku);
    if (sku) out.sku = sku;
    var price = p.price != null ? p.price : money(v && v.price);
    if (price != null) {
      out.price = price;
      var curr = getCurrency(p.currency);
      if (curr) out.currency = curr;
    }
    var cat = p.product_category || (prod && prod.type);
    if (cat) out.product_category = cat;
    var brand = p.product_brand || (prod && prod.vendor);
    if (brand) out.product_brand = brand;
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      out.product_collections = p.product_collections;
    }
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) out[k] = extra[k]; } }
    return out;
  }

  var template = currentTemplate();

  track('page_view', {
    page_name: template || 'page',
    signin: isSignedIn()
  });

  if (template.indexOf('product') === 0) {

    var source = 'direct';
    try {
      var ref = typeof document.referrer === 'string' ? document.referrer : '';
      if (ref) {
        var u = new URL(ref);
        if (u.origin === window.location.origin) {
          var path = (u.pathname || '').toLowerCase();
          if (path.indexOf('/search') !== -1) source = 'search';
          else if (path.indexOf('/cart') !== -1) source = 'cart';
          else if (path.indexOf('/collections/') !== -1) source = 'collection';
          else if (path.indexOf('wishlist') !== -1) source = 'wishlist';
          else if (path.indexOf('/account') !== -1) source = 'account';
          else if (path === '/' || path === '') source = 'home';
          else source = 'other';
        } else source = 'external';
      }
    } catch (e) {}

    track('product_viewed', productProps({
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn(),
      source: source
    }));
  }

  function fireCartViewed() {
    track('cart_viewed', {
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn()
    });
  }
  if (template === 'cart') {
    fireCartViewed();
  } else {
    var lastCartOpenAt = 0;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('.js-drawer')
        || t.closest('a[href="/cart"]')
        || t.closest('[data-cart-toggle], #cart-icon-bubble, [js-cart-drawer-open]');
      if (!opener) return;
      var now = Date.now();
      if (now - lastCartOpenAt < 600) return;
      lastCartOpenAt = now;
      fireCartViewed();
    }, true);
  }

  function trackCartAdd(payload) {
    var item = null;
    if (payload && Array.isArray(payload.items) && payload.items.length) item = payload.items[0];
    else if (payload && payload.id) item = payload;
    if (!item) return;
    var props = {
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn()
    };
    if (item.id != null) props.id = item.id;
    if (item.sku) props.sku = item.sku;
    var price = money(item.price);
    if (price != null) {
      props.price = price;
      var curr = getCurrency((payload && payload.cart && payload.cart.currency) || item.currency);
      if (curr) props.currency = curr;
    }
    if (item.product_type) props.product_category = item.product_type;
    if (item.vendor) props.product_brand = item.vendor;
    var p = params();
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      props.product_collections = p.product_collections;
    }
    track('added_to_cart', props);
    markCartTryOnCompleted();
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isAdd = url.indexOf('/cart/add') !== -1;
      var call = nativeFetch.apply(this, arguments);
      if (!isAdd) return call;
      return call.then(function (res) {
        try {
          res.clone().json().then(trackCartAdd).catch(function () {});
        } catch (e) {}
        return res;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__dxCartAdd = String(url || '').indexOf('/cart/add') !== -1; } catch (e) {}
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__dxCartAdd) {
      this.addEventListener('load', function () {
        try { trackCartAdd(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    return nativeSend.apply(this, arguments);
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('cart') === -1) return;
    var submitter = e.submitter;
    var isCheckout = submitter && (submitter.name === 'checkout' || submitter.getAttribute('name') === 'checkout');
    if (!isCheckout) return;

    e.preventDefault();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutUrl = root.replace(/\/?$/, '') + '/checkout';
    var done = false;
    function go() { if (done) return; done = true; window.location.href = checkoutUrl; }
    setTimeout(go, 1500);

    markCartTryOnCompleted();

    try {
      fetch(root.replace(/\/?$/, '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var first = (cart.items || [])[0];
          var props = { try_on_completed: hasCompletedTryOn() };
          if (first) {
            if (first.id != null) props.id = first.id;
            if (first.sku) props.sku = first.sku;
            var price = money(first.price);
            if (price != null) {
              props.price = price;
              var curr = getCurrency(cart && cart.currency);
              if (curr) props.currency = curr;
            }
            if (first.product_type) props.product_category = first.product_type;
            if (first.vendor) props.product_brand = first.vendor;
          }
          track('checkout_started', props);
          setTimeout(go, 150);
        })
        .catch(function () {
          track('checkout_started', { try_on_completed: hasCompletedTryOn() });
          setTimeout(go, 150);
        });
    } catch (err) {
      track('checkout_started', { try_on_completed: hasCompletedTryOn() });
      go();
    }
  }, true);

  function isSizeOptionControl(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toLowerCase();
    if (tag !== 'select' && tag !== 'input') return false;
    if (el.hasAttribute && el.hasAttribute('js-product-option-selector')) return true;
    if (!/SingleOptionSelector/i.test(el.id || '')) return false;

    var label = null;
    try { label = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]'); } catch (e) {}
    if (!label) {
      var wrap = el.closest && el.closest('.selector-wrapper, .variant-wrapper, .product-block');
      label = wrap && wrap.querySelector('label, .variant__label');
    }
    if (label && /size/i.test(label.textContent || '')) return true;

    return (el.getAttribute('data-index') || '') === 'option1';
  }

  if (template.indexOf('product') === 0) {

    function sizeProps(input, resolvedVariantId) {
      var p = params();
      var prod = metaProduct();
      var out = { try_on_completed: hasCompletedTryOn() };
      var variantId = (input && input.getAttribute('data-variant-id'))
        || resolvedVariantId
        || (p.variant_id != null ? p.variant_id : '')
        || currentVariantId();
      if (variantId) out.id = variantId;
      var cat = p.product_category || (prod && prod.type);
      if (cat) out.product_category = cat;
      var brand = p.product_brand || (prod && prod.vendor);
      if (brand) out.product_brand = brand;
      if (Array.isArray(p.product_collections) && p.product_collections.length) {
        out.product_collections = p.product_collections;
      }
      var v = metaVariant();
      var sku = p.sku || (v && v.sku);
      if (sku) out.sku = sku;
      var price = p.price != null ? p.price : money(v && v.price);
      if (price != null) {
        out.price = price;
        var curr = getCurrency(p.currency);
        if (curr) out.currency = curr;
      }
      return out;
    }

    var lastSizeInput = null;
    var lastSizeAt = 0;
    function fireSizeSelected(input) {
      if (!input) return;
      var now = Date.now();
      if (input === lastSizeInput && (now - lastSizeAt) < 400) return;
      lastSizeInput = input;
      lastSizeAt = now;

      var before = currentVariantId();
      var attempts = 0;
      (function settle() {
        var current = currentVariantId();
        if ((current && current !== before) || attempts >= 20) {
          track('size_selected', sizeProps(input, current || before));
          return;
        }
        attempts += 1;
        setTimeout(settle, 50);
      })();
    }

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!isSizeOptionControl(el)) return;
      fireSizeSelected(el);
    }, true);

    document.addEventListener('click', function (e) {
      var label = e.target && e.target.closest && e.target.closest('label[for]');
      if (!label) return;
      var input = document.getElementById(label.getAttribute('for'));
      if (!isSizeOptionControl(input)) return;
      fireSizeSelected(input);
    }, true);
  }

  function fireSearchOpened(el) {

    var input = document.getElementById('header-search')
      || document.querySelector('form[role="search"] input[type="search"]');
    var query = (input && input.value) ? input.value.trim() : '';
    var inDrawer = !!(el && el.closest && (el.closest('#SearchDrawer') || el.closest('[class*="drawer"]')));
    track('search_opened', {
      signin: isSignedIn(),
      query: query,
      source: inDrawer ? 'drawer' : 'header'
    });
  }

  document.addEventListener('click', function (e) {

    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[js-search-drawer-open]')
      || t.closest('.js-search')
      || t.closest('.btn--search')
      || t.closest('a[href="/search"], a[href^="/search?"]');
    if (trigger) fireSearchOpened(trigger);
  }, true);

  function markLoginInitiated() {
    try { sessionStorage.setItem(LOGIN_FLAG_KEY, '1'); } catch (err) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (String(form.action).indexOf('/account/login') === -1) return;
    markLoginInitiated();
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/account/login') !== -1
      || href.indexOf('customer_authentication/redirect') !== -1) {
      markLoginInitiated();
    }
  }, true);

  try {
    if (sessionStorage.getItem(LOGIN_FLAG_KEY) === '1' && isSignedIn()) {
      sessionStorage.removeItem(LOGIN_FLAG_KEY);
      track('login', { status: 'login successful' });
    }
  } catch (e) {}

  window.addEventListener('klaviyoForms', function (e) {
    var type = e && e.detail && e.detail.type;
    if (type !== 'submit') return;
    track('email_submitted', { description: 'user submitted email' });
  });

  function isShopifyEmailForm(form) {
    if (!form) return false;
    var type = form.querySelector('input[name="form_type"]');
    if (type && type.value === 'customer') return true;
    return !!(form.querySelector('input[name="contact[email]"]') || form.querySelector('input[name="customer[email]"]'));
  }

  document.addEventListener('submit', function (e) {
    if (!isShopifyEmailForm(e.target)) return;
    try { sessionStorage.setItem(EMAIL_FLAG_KEY, '1'); } catch (err) {}
  }, true);

  try {
    if (sessionStorage.getItem(EMAIL_FLAG_KEY) === '1') {
      sessionStorage.removeItem(EMAIL_FLAG_KEY);
      track('email_submitted', { description: 'user submitted email' });
    }
  } catch (e) {}
})();
